import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useRouter();
  const burgerMenuOperner = () => {
    setMenuOpen(!menuOpen);
  };

  const mainMenus = [
    "designverification",
    "physicaldesign",
    "firmware",
    "ic",
    "infrastructure",
  ];
  let requiredClasses = ["border-b-4", "border-blue-500"];
  let hoverClasses = ["hover:border-blue-400"];

  const sectionVisible = () => {
    let url = window.location.href;
    let result = false;
    if (url.split("#").length >= 2) {
      result = true;
    }
    return result;
  };

  const getAbsoulateUrlSection = () => {
    let url = window.location.href;
    let suffix = "menu";
    let takeLastPiece = url.split("#").slice(-1).pop(); // taking as string from last segment
    return [takeLastPiece, suffix].join("-");
  };

  const setActive = (currentlySelectedSection) => {
    let element = document.getElementById(currentlySelectedSection);
    element.classList.remove("border-transparent");
    requiredClasses.forEach((elem) => {
      element.classList.add(elem);
    });
  };

  const clearPreviousAllActiveClasses = () => {
    mainMenus.forEach((element) => {
      let currentElement = document.getElementById(element);
      requiredClasses.forEach((elem) => {
        currentElement.classList.remove(elem);
      });
      hoverClasses.forEach((elem) => {
        currentElement.classList.add(elem);
      });
    });
  };

  const activeClassForMainPage = () => {
    let specialCaseToNotApplyActiveClass = "vlsi";
    let result = true;
    if (pathname.split("/")[1] === specialCaseToNotApplyActiveClass) {
      result = false;
    }
    return result;
  };

  useEffect(() => {
    if (sectionVisible()) {
      if (activeClassForMainPage()) {
        setActive(pathname.split("/")[1]);
      }
    } else {
      if (activeClassForMainPage()) {
        setActive(pathname.split("/")[1]);
      }
    }
  });

  return (
    <div className="flex w-full bg-black">
      <div className="lg:w-1/5 2xl:w-1/5 flex lg:pl-10 2xl:pl-28 ">
        <h2 className="grid place-items-center">
          <Link href="/vlsi">
            <a className="text-white font-headline font-bold text-4xl">VLSI</a>
          </Link>
        </h2>
      </div>
      <div className="lg:w-4/5 2xl:w-4/5 flex">
        <div className="w-3/4 flex pr-16">
          <ul className="flex justify-between w-full pt-6 text-white gap-3">
            <li className="">
              <Link href="/vlsi/designverification">
                <a
                  href="/vlsi/designverification"
                  className="pb-6 flex border-b-4 border-transparent font-headline font-bold text-base xl:text-xl"
                  id="designverification"
                >
                  Design and Verification
                </a>
              </Link>
            </li>
            <li className="">
              <Link href="/vlsi/physicaldesign">
                <a
                  href="/vlsi/physicaldesign"
                  className="pb-6 flex hover:border-b-4 hover:border-blue-500 font-headline font-bold text-base xl:text-xl"
                  id="physicaldesign"
                >
                  Physical Design
                </a>
              </Link>
            </li>
            <li className="">
              <Link href="/vlsi/firmware">
                <a
                  href="/vlsi/firmware"
                  className="pb-6 flex hover:border-b-4 hover:border-blue-500 font-headline font-bold text-base xl:text-xl"
                  id="firmware"
                >
                  Firmware
                </a>
              </Link>
            </li>
            <li className="">
              <Link href="/vlsi/IC-Packaging">
                <a
                  href="/vlsi/IC-Packaging"
                  className="pb-6 flex hover:border-b-4 hover:border-blue-500 font-headline font-bold text-base xl:text-xl"
                  id="IC-Packaging"
                >
                  IC Package Design
                </a>
              </Link>
            </li>
            <li className="">
              <Link href="/vlsi/infrastructure">
                <a
                  href="/vlsi/infrastructure"
                  className="pb-6 flex hover:border-b-4 hover:border-blue-500 font-headline font-bold text-base xl:text-xl"
                  id="infrastructure"
                >
                  Infrastructure
                </a>
              </Link>
            </li>

            <li className="">
              <Link href="/blogs">
                <a
                  href="/blogs"
                  className="pb-6 flex hover:border-b-4 hover:border-blue-500 font-headline font-bold text-base xl:text-xl"
                  id="blog-menu"
                >
                  Blog
                </a>
              </Link>
            </li>
          </ul>
        </div>
        <div
          id="dynamic-menu-image-section"
          className="grid place-items-center lg:w-1/4 bg-blue-500 hover:bg-black"
        >
          <Link href="/">
            <a title="Home">
              <img
                className=""
                alt="Logo of Dynamic Solution Innovators Ltd."
                src="/images/dsi_logo.svg"
              />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
